import Navbar from "./Navbar";
import Contact from "./Navbar/Contact";
import Paypal from "./Navbar/Paypal";
import Tools from "./Navbar/Tools";
import Consigne from "./Consigne";
import Aide from "./Navbar/Aide";
import Tool from "./Tool";

import { useState } from "react";
import "./app.scss";

function App() {
    const path = "https://micetf.fr";
    const tool = "Mur sonore (Générateur de cartes)";
    const [show, setShow] = useState(true);

    function handleToggle() {
        setShow(!show);
    }

    return (
        <>
            <Navbar
                path={path}
                tool={tool}
                right={[
                    <Aide toggle={handleToggle} />,
                    <Paypal />,
                    <Tools path={path} />,
                    <Contact tool={tool} />,
                ]}
            />
            <Consigne show={show} toggle={handleToggle} />
            <Tool />
        </>
    );
}

export default App;
